/* eslint-disable max-len */
/* eslint-disable react/no-unescaped-entities */
import React from 'react'

const AcademicReportsEmptyScreen = ({emptyScreen, noRecords}) => {
    return (
        <div class="h-customh10 w-full flex justify-center items-center px-10">
            {noRecords ? 
                <div>
                    <div>
                        <img loading="lazy" decoding="async" src="/images/listingPageEmptyscreen.svg" alt="img" class="mx-auto" />
                        <p class="text-center text-f2 font-medium text-[#000000] pt-5">No academic reports uploaded yet. Click the three dots button to download the sample file or upload your report.</p>
                    </div>
                </div>
                :
                (
                    <div>
                        <img loading="lazy" decoding="async" src="/images/dashboardEmptyPage.svg" alt="img" class="mx-auto" />
                        <p class="text-center text-f2 font-medium text-[#000000] pt-5">Select 'Academic Year', 'Class', 'Section' and 'Exam' to view Academic Reports</p>
                    </div>
                )
            }
        </div>
    )
}

export default AcademicReportsEmptyScreen